import { createContext, useContext } from 'react';

import type { ToastItem } from '@/shared/components/Toast';

export type ToastMessage = Omit<ToastItem, 'id'>;
export const ToastContext = createContext<((message: ToastMessage) => void) | null>(null);
export const ToastResetContext = createContext<(() => void) | null>(null);

export function useToast() {
  const notify = useContext(ToastContext);
  if (notify === null) throw new Error('useToast must be used inside ToastProvider');
  return notify;
}

const nothingToClear = () => undefined;

/**
 * OBS-007 — takes every message off the screen at once: a message says what the
 * person who was signed in just did, so it goes when they do. Outside a
 * ToastProvider there is no message to take away.
 */
export function useResetToasts(): () => void {
  return useContext(ToastResetContext) ?? nothingToClear;
}
